/* eslint-disable max-len */
import styled from 'styled-components'

export const DropdownMenuWrapper = styled.div`
  position: absolute;
  z-index: 3;

  ${({ direction }) => direction === 'down' && 'top: 100%;'}
  ${({ direction }) => direction === 'up' && 'bottom: 100%;'}
  
  ${({ end }) => !end && 'left: 0;'}
  ${({ end }) => end && 'right: 0;'}
  
  ${({ isOpen, theme }) => isOpen &&
    `max-height: 700px; 
    padding: 5px; 
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15); 
    overflow: visible;
    border: 1px solid ${theme.colors.borderColor};`
  }
  ${({ isOpen, theme }) => !isOpen && `
    max-height: 0; 
    padding: 0px; 
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0); 
    overflow: hidden;
    border: 0px solid ${theme.colors.borderColor};`
  }


  margin: 5px 0;
  background: ${({ theme }) => theme.colors.background};
  border-radius: 10px;
  min-width: 230px;

  transition: 0.2s;
`
